var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tips.show),expression:"tips.show"}],staticClass:"tips"},[_c('h3',[_vm._v(_vm._s(_vm.tips.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }